/**
 * @generated SignedSource<<72e2a5259a2d15e61daba8e63d762c4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_user">;
  readonly " $fragmentType": "PdpRespSimilarItemsCarousel_user";
};
export type PdpRespSimilarItemsCarousel_user$key = {
  readonly " $data"?: PdpRespSimilarItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1f63f9b96b9b574c749aa07f65abb8eb";

export default node;
